import { enumRecordToCheckboxOptions } from '@umss/shared/utils';

export enum FacilityType {
  ADDICTION_SERVICE_CLINIC = 16,
  ASSISTED_LIVING = 7,
  BEHAVIOURAL_CENTER = 21,
  BIRTH_CENTER = 17,
  BLOOD_BANK = 12,
  DIALYSIS_CENTER = 9,
  GENERAL_HOSPITAL = 1,
  HOME_HEALTH_CARE = 8,
  HOSPICE_CARE = 18,
  LONG_TERM_ACUTE_CARE_CENTER = 19,
  LONG_TERM_CARE_FACILITY = 3,
  MEMORY_CARE_AND_ALZHEIMERS_FACILITIES = 13,
  PLASMA_CENTER = 14,
  PRIMARY_CARE_CLINIC = 2,
  PSYCHIATRIC_HOSPITAL = 10,
  REGIONAL_HOSPITAL = 11,
  REHABILITATION_FACILITY = 4,
  SKILLED_NURSING_FACILITIES = 15,
  SPECIALIZED_CLINIC = 6,
  URGENT_CARE_CLINIC = 5,
  WOUND_CLINIC = 20,
  DENTAL_OFFICE = 22
}

export const FACILITY_TYPES_RECORD: Record<FacilityType, string> = {
  [FacilityType.ADDICTION_SERVICE_CLINIC]: 'Addiction Service Clinic',
  [FacilityType.ASSISTED_LIVING]: 'Assisted Living',
  [FacilityType.BEHAVIOURAL_CENTER]: 'Behavioural Center',
  [FacilityType.BIRTH_CENTER]: 'Birth Center',
  [FacilityType.BLOOD_BANK]: 'Blood Bank',
  [FacilityType.DIALYSIS_CENTER]: 'Dialysis Center',
  [FacilityType.GENERAL_HOSPITAL]: 'General Hospital',
  [FacilityType.HOME_HEALTH_CARE]: 'Home Health Care',
  [FacilityType.HOSPICE_CARE]: 'Hospice Care',
  [FacilityType.LONG_TERM_ACUTE_CARE_CENTER]: 'Long Term Acute Care Center',
  [FacilityType.LONG_TERM_CARE_FACILITY]: 'Long Term Care Facility',
  [FacilityType.MEMORY_CARE_AND_ALZHEIMERS_FACILITIES]:
    "Memory Care and Alzheimer's Facilities",
  [FacilityType.PLASMA_CENTER]: 'Plasma Center',
  [FacilityType.PRIMARY_CARE_CLINIC]: 'Primary Care Clinic',
  [FacilityType.PSYCHIATRIC_HOSPITAL]: 'Psychiatric Hospital',
  [FacilityType.REGIONAL_HOSPITAL]: 'Regional Hospital',
  [FacilityType.REHABILITATION_FACILITY]: 'Rehabilitation Facility',
  [FacilityType.SKILLED_NURSING_FACILITIES]: 'Skilled Nursing Facilities',
  [FacilityType.SPECIALIZED_CLINIC]: 'Specialized Clinic',
  [FacilityType.URGENT_CARE_CLINIC]: 'Urgent Care Clinic',
  [FacilityType.WOUND_CLINIC]: 'Wound Clinic',
  [FacilityType.DENTAL_OFFICE]: 'Dental Office'
};

export const FACILITY_TYPES_DESCRIPTIONS_RECORD: Record<FacilityType, string> =
  {
    [FacilityType.ADDICTION_SERVICE_CLINIC]:
      'Clinic providing treatment and support for substance abuse and addiction',
    [FacilityType.ASSISTED_LIVING]: 'Assisted living facility',
    [FacilityType.BEHAVIOURAL_CENTER]:
      'Facility providing comprehensive behavioral health and mental health services',
    [FacilityType.BIRTH_CENTER]:
      'Facility specializing in natural childbirth and maternal care',
    [FacilityType.BLOOD_BANK]:
      'Facility for collection, testing, and storage of blood products',
    [FacilityType.DIALYSIS_CENTER]: 'Dialysis treatment center',
    [FacilityType.GENERAL_HOSPITAL]: 'General hospital facility',
    [FacilityType.HOME_HEALTH_CARE]: 'Home health services',
    [FacilityType.HOSPICE_CARE]:
      'Compassionate end-of-life care facility for terminally ill patients',
    [FacilityType.LONG_TERM_ACUTE_CARE_CENTER]: 'Long term acute care center',
    [FacilityType.LONG_TERM_CARE_FACILITY]: 'Long term care facility',
    [FacilityType.MEMORY_CARE_AND_ALZHEIMERS_FACILITIES]:
      "Memory care and Alzheimer's facilities",
    [FacilityType.PLASMA_CENTER]: 'Facility for plasma collection and donation',
    [FacilityType.PRIMARY_CARE_CLINIC]:
      'Primary care clinic providing general health services',
    [FacilityType.PSYCHIATRIC_HOSPITAL]:
      'Hospital specializing in psychiatric care',
    [FacilityType.REGIONAL_HOSPITAL]: 'Regional hospital facility',
    [FacilityType.REHABILITATION_FACILITY]:
      'Facility providing rehabilitation services',
    [FacilityType.SKILLED_NURSING_FACILITIES]:
      'Skilled nursing facilities providing specialized care',
    [FacilityType.SPECIALIZED_CLINIC]:
      'Clinic specializing in specific medical fields',
    [FacilityType.URGENT_CARE_CLINIC]: 'Clinic providing urgent care services',
    [FacilityType.WOUND_CLINIC]: 'Clinic specializing in wound care',
    [FacilityType.DENTAL_OFFICE]: 'Dental office providing oral health services'
  };

export const FACILITY_TYPES_LIST = enumRecordToCheckboxOptions(
  FACILITY_TYPES_RECORD,
  {
    descriptionsRecord: FACILITY_TYPES_DESCRIPTIONS_RECORD,
    sortByLabel: 'alphabetical'
  }
);
